import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom';
const Header = ({ isLogged }) => {
    const handleClick = () => {
        localStorage.clear();
        isLogged(false)
        //history.push('/')
    };
   
    const [username, setusername] = useState("")
    const [logo, setlogo] = useState("")
    const [minlogo, setminlogo] = useState("")
    const [usertypenames, setusertypename] = useState("")
   /*  const [userids, setuserid] = useState("") */
    useEffect(() => {
        if (localStorage.getItem("Username")) {
            debugger;
            var data = localStorage.getItem("Username");
            var logo =  localStorage.getItem("logo");
            var minlogo = localStorage.getItem("minlogo");
            var usertypename = localStorage.getItem("userTypename");
            /* var userid = localStorage.getItem("userid"); */
            setusername(data)
            setlogo(logo)
            setminlogo(minlogo)
            setusertypename(usertypename)
           /*  setuserid(userid) */

        }
    })
    return (
        <>

            <div className="nav-header">
                <Link to="/" className="brand-logo">
                    {/*<img className="logo-abbr" src="Assets/images/Royal-logo-short.svg" alt="royal farm house logo" />*/}
                    {/*<img className="brand-title" src="Assets/images/Royal-logo-white.svg" alt="royal farm house logo" />*/}
                    <img className="logo-abbr" src={'data:image/png;base64,' + minlogo} alt="FH logo" />
                    <img className="brand-title" src={'data:image/png;base64,' + logo} alt="FH logo" />
                </Link> 
                <div className="nav-control">
                    <div className="hamburger">
                        <span className="line"></span><span className="line"></span><span className="line"></span>
                    </div>
                </div>
            </div>
            <div className="header">
                <div className="header-content">
                    <nav className="navbar navbar-expand">
                        <div className="collapse navbar-collapse justify-content-between">
                            <div className="header-left">
                                <div className="dashboard_bar">
                                    Dashboard
                                </div>
                            </div>
                            <ul className="navbar-nav header-right">
                                <li className="nav-item dropdown header-profile">
                                    <Link className="nav-link" to="/" role="button" data-bs-toggle="dropdown">
                                        <img src="Assets/images/user-icon.png" alt="user image" />
                                        <div className="header-info ms-3">
                                            <span>{username}. {usertypenames} </span>
                                           {/*  <span className='user-ID'>User Id: <strong>{userids}</strong></span> */}
                                            {/* <small>Superadmin</small>*/}
                                        </div>
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-end">
                                        {/* change password */}
                                        <span className="dropdown-item ai-icon">
                                            <i className="fas flaticon-007-bulleye"></i>
                                            <Link className="ms-2" to="/change">Change Password</Link>
                                        </span>
                                        <span className="dropdown-item ai-icon">
                                            <svg id="icon-logout" xmlns="http://www.w3.org/2000/svg" className="text-danger"
                                                width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                            >
                                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                                <polyline points="16 17 21 12 16 7"></polyline>
                                                <line x1="21" y1="12" x2="9" y2="12"></line>
                                            </svg>
                                            <Link to="" className="ms-2 lg-out" onClick={handleClick}>Logout</Link>
                                        </span>
                                       
                                    </div>
                                    
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </>
    )
}
export default Header;